// 对于axios进行二次封装
import axios from "axios";
import { MessageBox, Message } from 'element-ui'
import nprogress from "nprogress";
import store from '@/store';
import "nprogress/nprogress.css";
import router from "@/router";
const requests = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
});

// 请求拦截器
requests.interceptors.request.use((config) => {
  // 需要携带token带给服务器
  if (store.getters['user/token']) {
    config.headers['Authorization'] = store.getters['user/token'] // 这个 headers['token']要和后端商量，有可能是 headers['Authorization']
  }
  nprogress.start();
  return config;
},
error => {
  console.log(error)
  return Promise.reject(error)
});

// 响应拦截器
requests.interceptors.response.use(
  ({ data }) => {
    console
    nprogress.done();
    if (data && data.httpCode === 200) {
      return data;
    } else if (data.size) {
      return data;
    } else {
      Message({
        message: data.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(data));
    }
  },
  (err) => {
    nprogress.done();
    if (err.response) {
      const { data } = err.response;
      if (data.httpCode === 401) {
        MessageBox.confirm('已登出或者token无效', '确认登出', {
          confirmButtonText: '重新登陆',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          store.dispatch('user/clearToken');
          router.push('/login?redirect=' + router.currentRoute.fullPath);
        }).catch(() => {
          store.dispatch('user/clearToken');
          location.reload();
        })
        return Promise.reject(data);
      } else {
        switch (data.statusCode) {
          case 429: {
            break;
          }
          default: {
            Message({
              message: data.message,
              type: 'error',
              duration: 5 * 1000
            })
            break;
          }
        }
        return Promise.resolve(data);
      }
    } else {
      Message({
        message: '发生错误，请稍后重试',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err);
    }
  }
);
export default requests;
